import { render, staticRenderFns } from "./masideNav.vue?vue&type=template&id=27cc688c&scoped=true"
import script from "./masideNav.vue?vue&type=script&lang=js"
export * from "./masideNav.vue?vue&type=script&lang=js"
import style0 from "./masideNav.vue?vue&type=style&index=0&id=27cc688c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc688c",
  null
  
)

export default component.exports